var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_188","data-name":"Path 188","d":"M14.191,0H5.271A5.279,5.279,0,0,0,0,5.271v8.92a5.279,5.279,0,0,0,5.271,5.271h8.92a5.279,5.279,0,0,0,5.271-5.271V5.271A5.279,5.279,0,0,0,14.191,0ZM9.731,14.192a4.46,4.46,0,1,1,4.46-4.46A4.46,4.46,0,0,1,9.731,14.192ZM15,5.271a1.216,1.216,0,1,1,1.216-1.216A1.216,1.216,0,0,1,15,5.271Z","fill":"#707070"}));
}

Instagram.defaultProps = {"width":"19.462","height":"19.463","viewBox":"0 0 19.462 19.463"};

module.exports = Instagram;

Instagram.default = Instagram;
